import React from 'react';
import PropTypes from 'prop-types';
import { BarChart } from '@mui/x-charts/BarChart';
import dayjs from 'dayjs';

export default function BasicBars({ data } = {}) {
  const startDate = dayjs().startOf('month');
  const today = dayjs();

  const getDaysArray = (start, end) => {
    const days = [];
    let current = dayjs(start);
    const stopDate = dayjs(end);

    while (current.isBefore(stopDate) || current.isSame(stopDate, 'day')) {
      days.push(current);
      current = current.add(1, 'day');
    }
    return days;
  };

  const array = getDaysArray(startDate, today);

  const formatData = () => {
    if (!data || !data.report) return null;
    const values = array.map((day) => {
      const key = day.format('MM/DD/YY');
      const entry = data.report[key];
      return entry ? entry.overallRevenue : 0;
    });
    if (values.every((v) => v === 0)) return null;
    return { data: values, color: '#425998' };
  };

  const formattedData = formatData();
  const series = formattedData ? [formattedData] : [];

  return (
    <BarChart
      xAxis={[{ data: array.map((day) => day.format('MM/DD')) }]}
      yAxis={[{ valueFormatter: (value) => (value >= 1000 ? `${(value / 1000).toFixed(value % 1000 === 0 ? 0 : 1)}k` : `${value}`) }]}
      series={series}
      height={300}
      loading={!!(data && data.loading)}
      localeText={{ noData: 'No data to display' }}
    />
  );
}

BasicBars.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    report: PropTypes.objectOf(
      PropTypes.shape({
        overallRevenue: PropTypes.number,
      }),
    ),
  }),
};
